import React, { Component } from 'react'
import { withNamespaces } from "react-i18next"
import commaNumber from "comma-number"
import StringHelper from "../../common/helpers/string_helper"
import './listing.scss'

class Listing extends Component {
  get photoURL() {
    return `${this.props.roomGroup.photos_imgix[0]}?auto=format&auto=compress&fit=min&dpr=${this.devicePixelRatio || 1}`
  }

  render() {
    const { t, roomGroup, i18n: { language } } = this.props
    return (
      <li styleName="listing" className="js-swiper-slide swiper-slide">
        <a styleName="listing-link" href={routeUrlHelper.listingPath(roomGroup.id)} target="_blank">
          <div styleName="pickup-image" className="js-swiper-slide-image" style={{ backgroundImage: `url(${this.photoURL})` }}></div>
          <div styleName="pickup__info">
            <div styleName="location"><span className="vs-icon-pin"></span><span>{ StringHelper.getPreferredLanguageString(roomGroup.property.prefecture, language) }</span></div>
            <div styleName="room-group-name">{ StringHelper.getPreferredLanguageString(roomGroup.room_title, language) }</div>
            <span className="maximum-guests"> {t('vietnam.maximum_guests', { count: roomGroup.maximum_guests })}</span>
            <span className="bedrooms">・{t('vietnam.bedrooms', { count: roomGroup.bedrooms })}</span>
            <span className="beds">・{t('vietnam.beds', { count: roomGroup.beds })}</span>
            <div className="price">{t('vietnam.price', { price: commaNumber(roomGroup.min_price) })}</div>
          </div>
        </a>
      </li>
    )
  }
}

export default withNamespaces('vietnam')(Listing)
